import React, { useState, useEffect, useRef } from 'react';
import { formatDate, isSameDate } from '../../utils/dateUtils';

function DatePicker({ value, onChange, placeholder = '日付を選択' }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(value ? new Date(value) : null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (value) {
      setSelectedDate(new Date(value));
      // 選択された日付の月を表示
      setCurrentMonth(new Date(value));
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // wrapper全体の外をクリックした場合のみ閉じる
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const renderCalendar = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());

    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
    const monthNames = [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ];

    const days = [];
    const currentDate = new Date(startDate);

    for (let i = 0; i < 42; i++) {
      const isCurrentMonth = currentDate.getMonth() === month;
      const isSelected =
        selectedDate && isSameDate(currentDate, selectedDate);
      const isToday = isSameDate(currentDate, new Date());

      days.push({
        date: new Date(currentDate),
        isCurrentMonth,
        isSelected,
        isToday,
      });

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return (
      <div className="calendar-popup">
        <div className="calendar-header">
          <button
            type="button"
            className="calendar-nav-btn"
            onClick={() => {
              const newMonth = new Date(currentMonth);
              newMonth.setMonth(newMonth.getMonth() - 1);
              setCurrentMonth(newMonth);
            }}
          >
            ‹
          </button>
          <div className="calendar-month-year">
            {year}年{monthNames[month]}
          </div>
          <button
            type="button"
            className="calendar-nav-btn"
            onClick={() => {
              const newMonth = new Date(currentMonth);
              newMonth.setMonth(newMonth.getMonth() + 1);
              setCurrentMonth(newMonth);
            }}
          >
            ›
          </button>
        </div>
        <div className="calendar-grid">
          {weekdays.map((day) => (
            <div key={day} className="calendar-day-header">
              {day}
            </div>
          ))}
        </div>
        <div className="calendar-grid">
          {days.map((day, idx) => {
            let classes = 'calendar-day';
            if (!day.isCurrentMonth) {
              classes += ' other-month';
            }
            if (day.isSelected) {
              classes += ' selected';
            }
            if (day.isToday) {
              classes += ' today';
            }

            return (
              <div
                key={idx}
                className={classes}
                onClick={() => {
                  if (day.isCurrentMonth) {
                    setSelectedDate(day.date);
                    onChange(formatDate(day.date));
                    setIsOpen(false);
                  }
                }}
              >
                {day.date.getDate()}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="date-picker-wrapper" style={{ position: 'relative' }} ref={wrapperRef}>
      <input
        type="text"
        value={value || ''}
        placeholder={placeholder}
        readOnly
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer' }}
      />
      {isOpen && (
        <div style={{ position: 'absolute', zIndex: 1000, top: '100%', left: 0 }}>
          {renderCalendar()}
        </div>
      )}
    </div>
  );
}

export default DatePicker;

